import type { ButtonVariant } from "@mantine/core";
import type { GlobalConfig } from "@simplrsupport/headless-chat-web";

import type { GuideStepVariant } from "../types";

/** simplr server (same server for all environments) */
export const SIMPLR_PUBLIC_SERVER_DOMAIN = "https://app.gosimplr.com";

export type LogicBuilderGlobalConfig = Pick<GlobalConfig, "customFlowSystemId" | "widgetId">;
export interface GuideAppConfig {
    widgetId?: string;
}

export interface GuideOption {
    label: string;
    value: string;
    skipsValidation?: boolean;
    variant?: ButtonVariant;
    customAction?: string;
}

export type GuideActionOption = GuideOption;

export interface GuideQuickInput {
    type: "DROPDOWN" | "BUTTONS" | "INPUT";
    options: GuideOption[];

    action?: GuideActionOption;
    label?: string;
    alternateText?: string;
    validationError?: string;
}

export type GuideDropdownInput = {
    type: "DROPDOWN";
    options: GuideOption[];
    label: string;
    action: GuideActionOption;
    required?: boolean;
    validationError?: string;
};

export type GuideTextInput = {
    type: "INPUT";
    label: string;
    action: GuideActionOption;
    inputType: "tel" | "text";
    placeholder: string;
    mask: string;
    options?: GuideOption[];
    validationRegExp: string;
    validationError: string;
};

export interface GuideMessage {
    data?: {
        stepId?: string;
    };
}

export interface GuideTextMessage extends GuideMessage {
    data?: {
        customData?: UiMetadata;
        isFirstStep?: boolean;
        quickInput?: GuideQuickInput;
        stepId?: string;
        tag?: string;
        variant?: GuideStepVariant;
        assistPrompt?: string;
    };
    progress?: {
        percent?: number;
    };
}

export interface GuideSelectionObject {
    title: string;
    icon: string;
    isGuideRecommendationDisabled?: boolean;
    employeeIds?: string[];
}
export interface GuideSelectionMessage extends GuideMessage {
    data?: {
        guideSelection: GuideSelectionObject[];
        stepId?: string;
    };
}

export interface UiMetadata {
    flowName: string;
    closeConfirmation?: {
        title: string;
        options: string[];
    }; // some partners do not want close confirmation feedback
}
